import {useEffect, useRef} from 'react';

/**
 * Custom React hook to save and return previous value of the input
 *
 * Useful to save previous props and state. Example pseudocode:
 *   BEFORE
 *     componentDidUpdate(prevProps) { [do something with prevProps and this.props] }
 *   AFTER
 *     const prevProps = usePrevious(props);
 *     useEffect({ [do something with prevProps and props] }, [prevProps, props]);
 *
 * Initially returns undefined.
 *
 * Adapted from https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
 */
export default function usePrevious<T>(value: T): T | undefined {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
